if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push((swat) => {
    document.querySelectorAll('swymcs-cart-wishlist-button').forEach((component) => {
      component.initialize(swat);
    });
  });

  if (!customElements.get('swymcs-cart-wishlist-button')) {
    class SwymCartWishlistButton extends HTMLElement {
      constructor() {
        super();
        if (!window.wishlistItemVariantIds) {
          window.wishlistItemVariantIds = [];
        }

        this.SwymWishlistData;
      }

      initialize(swat) {
        this.swat = swat;
        this.elements = this.getElements();

        if (!this.elements.wishlistButton) return;

        this.elements.wishlistButton.classList.add('swym-loaded');

        this.data = this.parseDataset(this.elements.wishlistButton);
        this.fetchAndUpdateWishlistState();
        this.initializeSwymWishlistData();

        this.setupEventListeners();
      }

      initializeSwymWishlistData() {
        this.SwymWishlistData = {
          et: 1, // event type
          empi: this.data.productId,
          epi: this.data.variantId,
          dt: this.data.productTitle,
          du: this.getProductUrl(this.data.productHandle),
          ct: this.data.productType,
          pr: parseInt(this.data.variantPrice) / 100,
          iu: this.data.featuredImage,
          variants: [{ [this.data.variantTitle]: this.data.variantId }],
          stk: this.data.stock,
          op: this.data.compareAtPrice ? parseInt(this.data.compareAtPrice) / 100 : undefined,
          uri: this.getVariantUrl(this.data.productHandle, this.data.variantId),
          available: this.data.available,
          vi: this.data.variantOption1,
        };
      }

      fetchAndUpdateWishlistState() {
        this.swat.fetch((products) => {
          const isInWishlist = products.find(
            (product) => product.empi == this.data.productId && product.epi == this.data.variantId
          );

          if (isInWishlist) {
            if (!window.wishlistItemVariantIds.includes(this.data.variantId)) {
              window.wishlistItemVariantIds.push(this.data.variantId);
            }
            this.elements.wishlistButton.classList.add('swym-added');
          } else {
            this.elements.wishlistButton.classList.remove('swym-added');
          }
        });
      }

      setupEventListeners() {
        if (this._handleClick) return;
        this._handleClick = this.handleClick.bind(this);
        this.elements.wishlistButton.addEventListener('click', this._handleClick);
      }

      handleClick() {
        if (!this.SwymWishlistData) return;

        if (this.elements.wishlistButton.classList.contains('swym-added')) {
          this.removeFromWishlist();
        } else {
          this.addToWishlist();
        }

        this.updateCount();
      }

      removeFromWishlist() {
          this.swat.api.removeFromWishList(this.SwymWishlistData, () => {
            let successMessage = window.cartStrings.removeFromWishlist
            .replace('__PRODUCT_TITLE__', this.data.productTitle)
            .replace('__VARIANT_TITLE__', this.data.variantTitle);
            this.swat.ui.showSuccessNotification({
              message: successMessage,
            });
            this.elements.wishlistButton.classList.remove('swym-added');
          });
      }

      addToWishlist() {
        this.SwymWishlistData.et = 4;

        this.swat.addToWishList(this.SwymWishlistData, () => {
          if (!window.wishlistItemVariantIds.includes(this.SwymWishlistData.epi)) {
            window.wishlistItemVariantIds.push(this.SwymWishlistData.epi);
          }

          this.elements.wishlistButton.classList.add('swym-added');
          let successMessage = window.cartStrings.addedToWishlist
            .replace('__PRODUCT_TITLE__', this.data.productTitle)
            .replace('__VARIANT_TITLE__', this.data.variantTitle);
          this.swat.ui.showSuccessNotification({
            message: successMessage,
          });
        });
      }

      getProductUrl(handle) {
        return `https://${window.location.host}${window.Shopify.routes.root}products/${handle}`;
      }

      getVariantUrl(handle, variantId) {
        return `${this.getProductUrl(handle)}?variant=${variantId}`;
      }

      getElements() {
        return {
          wishlistButton: this.querySelector('button'),
          unfilledState: this.querySelector('#swymUnfilled'),
          filledState: this.querySelector('#swymFilled'),
        };
      }

      updateCount() {
        const countHTMLElem = document.querySelector('.wishlist-count');
        this.swat.renderWishlistCount(countHTMLElem, () => {
          window.dispatchEvent(new CustomEvent('wishlist:updated'));
        });
      }

      disconnectedCallback() {
        if (this.elements?.wishlistButton && this._handleClick) {
          this.elements.wishlistButton.removeEventListener('click', this._handleClick);
        }
      }

      connectedCallback() {
        if (window._swat) {
          this.initialize(window._swat);
        }
      }

      parseDataset(button) {
        const raw = button.dataset;
        const parse = (val) => {
          try {
            return JSON.parse(val);
          } catch {
            return val;
          }
        };

        return {
          productId: parseInt(raw.productId),
          variantId: parseInt(raw.variantId),
          productTitle: parse(raw.productTitle),
          variantTitle: parse(raw.variantTitle),
          productUrl: parse(raw.productUrl),
          productHandle: parse(raw.productHandle),
          productType: parse(raw.productType),
          variantPrice: parseInt(parse(raw.variantPrice)) / 100,
          compareAtPrice: parse(raw.compareAtPrice) ? parseInt(parse(raw.compareAtPrice)) / 100 : undefined,
          featuredImage: parse(raw.featuredImage),
          stock: parse(raw.stock),
          available: parse(raw.available),
          variantOption1: parse(raw.variantOption1),
          uri: `https://${window.location.host + window.Shopify.routes.root}products/${parse(raw.productHandle)}?variant=${parseInt(raw.variantId)}`,
        };
      }

    }

    customElements.define('swymcs-cart-wishlist-button', SwymCartWishlistButton);
  }
